import { cva } from 'class-variance-authority';
import React from 'react';

type HighlightVariant = 'bg' | 'color';

type HighlightProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: HighlightVariant;
};

const highlightVariants = cva('inline-block whitespace-nowrap font-bold', {
  variants: {
    variant: {
      bg: 'bg-primary px-0.5 text-white',
      color: 'text-primary font-handwritten',
    },
  },
  defaultVariants: {
    variant: 'bg',
  },
});

export function Highlight({ children, className, variant = 'bg', ...props }: HighlightProps) {
  return (
    <span className={highlightVariants({ variant, className })} {...props}>
      {children}
    </span>
  );
}

export default Highlight;
